<template>
  <div class="container sections-menu"  v-if="showMenu" @click="toggleMenuState" @mouseleave="toggleMenuState"> <!---  v-if="showMenu" -->
    <div class="row d-none d-lg-flex">
      <div class="col-lg-4 programs">
        <h2 class="info mb-3">{{ $t('programs') }}
          {{ $t('menu.divide') }}
        </h2>
        <div class="d-flex" style="flex-direction: column">
           <div v-for="(category, i) in categories " 
           :key="i" class="d-block mt-0" > <!----:to="{ path: `/${$i18n.locale}/courses`, query: { category: 3 } }"-->
            <div class="course d-flex align-items-center py-0" @mouseenter="coursesOnHover(category.id)">
              <!-- <img  src="../../assets/images/about/about1.svg" alt="" class="icon" /> -->
              <div class="info-course">
                <h3 class="p-0 my-0">
                  {{ category?.name }}
                  <!-- {{ $t('menu.course1') }} -->
                </h3>
                <p></p>
              </div>
            </div>
          </div>
         
          
        </div>
      </div>
      <div class="col-lg-8 d-none d-lg-block">
        <div class="row more-courses">
          <div class="col-lg-4">
            <h3 class="text">
              {{ $t('menu.course4') }}
            </h3>
            <router-link :to="`/${$i18n.locale}/courses/${course.slug}`" class="link d-block"
              v-for="course in courses.recordedCourses" :key="course.slug">{{ course.name }} </router-link>
          </div>

          <div class="col-lg-4">
            <h3 class="text">
              {{ $t('menu.course6') }}
            </h3>
            <router-link :to="`/${$i18n.locale}/courses/${course.slug}`" class="link d-block"
              v-for="course in courses.onlineCourses" :key="course.slug">{{ course.name }} </router-link>
          </div>
          <div class="col-lg-4">
            <h3 class="text">
              {{ $t('menu.course5') }}
            </h3>
            <router-link :to="`/${$i18n.locale}/courses/${course.slug}`" class="link d-block"
              v-for="course in courses.offlineCourses" :key="course.slug">{{ course.name }} </router-link>
          </div>
         
        </div>
      </div>
    </div>
    <!------------------------->
  </div>
</template>
<script setup>
import apiClient from '@/Services/apiClient'
// import { computed, watch } from 'vue';
import { ref } from 'vue'
// import { useStore } from 'vuex'

defineProps(['categories'])
const showMenu = ref(true)
// const store = useStore();

const toggleMenuState = () => {
  showMenu.value = !showMenu.value
}
const coursesOnHover = async (id) => {
  const res = await apiClient.get(`courses/website/courses-on-hover?SpecializationId=${id}`);
  courses.value = res.data.data;
}
//const currentLanguage = computed(() => {store.getters.currentLanguage})
const courses = ref({})
// const categories =  computed(() => store.getters.categories)

// watch(currentLanguage, async (newLang, oldLang) => {
//   if (newLang !== oldLang) {
//     await store.dispatch('getCategories');
//   }
// },{immediate:true});

// onMounted(async () => {
//   await store.dispatch('getCategories');
// })

</script>
<style lang="scss" scoped>
/* Add your styles here */
$item-height: 50px;
$list-width: 310px;
$list-height: 90vh;

.sections-menu {
  width: 75.18rem;
  // height: 445px;
  flex-shrink: 0;
  position: absolute;
  top: 80px;
  border-radius: 29.211px;
  border: 1.328px solid var(--Neutral-300, #eff0f6);
  background: var(--Neutral-100, #fff);
  box-shadow: 0px 10.622px 21.245px 0px rgba(23, 15, 73, 0.03),
    0px 13.278px 18.589px 0px rgba(74, 58, 255, 0.01);

  &:lang(en) {
    left: 50px;
  }

  &:lang(ar) {
    right: 50px;
  }

  z-index: 30;

  // background: #fff;
  .programs {
    background-color: rgba(247, 247, 251, 1);
    padding: 40px;
  }

  .more-courses {
    padding: 40px;
  }

  .info {
    color: #020100;
    font-family: "Almarai", sans-serif;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.6563rem;
  }

  .course {
    .info-course {
      display: inline-flex;
      align-items: center;
      margin-right: 10px;
      padding: 11px 10px;
      // margin-top: 10px;
      
    
      h3 {
        color: #206387;
        font-family: "Almarai", sans-serif;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.3;
      }

      p {
        color: #6c6c6c;
        font-family: "Almarai", sans-serif;
        font-size: .875rem;
        font-weight: 400;
        line-height: 1.6563rem;
      }
    }

    &:hover {
      // padding: 10px;
      background-color: #fff;
      transition: all 0.3s;
      border-radius: 15px;
      cursor: pointer;
    }
  }

  .text,
  .course-text,
  .description,
  .link {

    font-family: "Almarai", sans-serif;
    font-feature-settings: "clig" off, "liga" off;
  }

  .text {
    color: #020100;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.6598rem;
  }

  .course-text {
    color: #206387;
    text-align: right;
    font-size: 0.75rem;
    font-weight: 400;
  }

  .description {
    font-size: .875rem;
    font-weight: 700;
  }

  .link {
    color: rgba(111, 108, 144, 1);
    font-size: 1rem;
    font-weight: 400;
    line-height: 2.5;
  }

  .img-section {
    position: relative;
    text-align: center;
    transition: all 0.5s;

    &:hover .img-content img {
      transform: translateY(10px);
      z-index: 1;
      opacity: 1;
      transition: all 0.3s;
    }
  }

  .img-content img {
    border-radius: 10px;
    width: 272px;
    height: 167px;
    object-fit: cover;
    opacity: 0.7;
  }

  .centered-text {
    position: absolute;
    top: 75%;
    left: 50%;
    transform: translate(-50%, -50%);

    h2 {
      margin: 0;
    }
  }
}

.icon {
  width: 53px;
}

@media screen and (max-width: 768px) {
  .sections-menu {
    position: relative;
  }
}
</style>